import { SvgIcon } from '../../../mui/SvgIcon';
import { UxSvgIconProps } from './types';

export function UxTableDensityCompact(props: UxSvgIconProps) {
  return (
    <SvgIcon {...props} preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24'>
      <path d='M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z' />
    </SvgIcon>
  );
}

export function UxTableDensityStandard(props: UxSvgIconProps) {
  return (
    <SvgIcon {...props} preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24'>
      <path d='M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z' />
    </SvgIcon>
  );
}

export function UxTableDensityComfortable(props: UxSvgIconProps) {
  return (
    <SvgIcon {...props} preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24'>
      <path d='M4 18h17v-6H4v6zM4 5v6h17V5H4z' />
    </SvgIcon>
  );
}
